import {atom} from 'recoil'


interface IState {
    phone: string,
    password: string
}

export const loginState = atom<IState>({
    key: 'loginState',
    default: {
        phone: '',
        password: ''
    }
})
